// extracted by mini-css-extract-plugin
module.exports = {"MachineParameters":"MachineParameters_MachineParameters__T3FfO"};